export default {
    props: {
        dataInteraction: {
            type: Object,
            required: true
        }
    },

    computed: {
        interaction() {
            return this.dataInteraction
        }
    },
}
